import AmbientNoiseVolumeSetting from "./ambient-noise-volume-setting";
import SettingsToggle from "../common/settings-toggle";
import { useSettingsData } from "../../../../contexts/SettingsDataContext";
import { memo } from "react";
import { Radio } from "lucide-react-native";

const AmbientNoiseSetting = () => {
  const { settings, handleAmbientNoise, isTestCallActive } = useSettingsData();

  return (
    <SettingsToggle
      title="Ambient Noise"
      description="Realistic restaurant noise that makes calls sound more natural."
      value={settings.ambientNoise}
      onValueChange={handleAmbientNoise}
      icon={Radio}
      disabled={isTestCallActive}
    >
      {settings.ambientNoise && <AmbientNoiseVolumeSetting />}
    </SettingsToggle>
  );
};

export default memo(AmbientNoiseSetting);
